export default __webpack_public_path__ + "static/media/Lato-Regular.74c41551.woff2";